import { useState } from 'react';
import { ConfirmModal } from './ConfirmModal';

interface ConfirmButtonProps {
  button: (openModal: () => void) => React.ReactNode;
  onConfirm: () => Promise<void> | void;
  confirmationDescription: string;
  confirmationButtonLabel?: string;
}

export function ConfirmButton(props: ConfirmButtonProps) {
  const { button, onConfirm, confirmationDescription, confirmationButtonLabel } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      {button(() => setOpen(true))}
      {open && (
        <ConfirmModal
          title="Confirmation"
          confirmLabel={confirmationButtonLabel}
          onConfirm={async () => {
            await onConfirm();
          }}
          closeModal={() => setOpen(false)}
        >
          <p>{confirmationDescription}</p>
        </ConfirmModal>
      )}
    </>
  );
}
